import { convertDotNotationToNested } from '../../../../pages/onboardingPageV2/helpers/convertObjToHistory';
import { ApiServiceBase } from '../../ApiServiceBase';
import { parsErrorMessageObj } from '../../utils/parsErrorMessageObj';
import { OnboardingRequestStatuses } from '../OnboardingApi/enums/OnboardingRequestStatuses';

interface IUpdateHistory {
    status: OnboardingRequestStatuses;
    matchedKeys: Record<string, Array<Record<string, unknown>>>;
    id: string;
    tab: string | undefined;
    options?: {
        hasAbroadAddress: boolean;
        hasSwissAddress: boolean;
        hasOtherJob: boolean | undefined;
        hasCBA: boolean | undefined;
        hasTreasury: boolean | undefined;
    };
}

class HistoryApi extends ApiServiceBase {
    baseUrl = '/api/v1/history';

    //ONBOARDING HISTORY
    getOnboardingHistoryTotal({ userId, keys }: any) {
        return this.get(`/${userId}/total?keys=${keys.join(`,`)}&isActive=false`)
            .then((response) => ({
                isSuccess: true,
                data: response,
            }))
            .catch((e) => ({
                isSuccess: false,
                data: parsErrorMessageObj(e),
            }));
    }
    getOnboardingActiveFields({ userId, keys }: any) {
        return this.get(`/${userId}?keys=${keys.join(`,`)}&isActive=true`)
            .then((response) => ({
                isSuccess: true,
                data: response,
            }))
            .catch((e) => ({
                isSuccess: false,
                data: parsErrorMessageObj(e),
            }));
    }
    getOnboardingHistoryFields({ userId, keys }: any) {
        return this.get(`/${userId}?keys=${keys.join(`,`)}&isActive=false`)
            .then((response) => ({
                isSuccess: true,
                data: response,
            }))
            .catch((e) => ({
                isSuccess: false,
                data: parsErrorMessageObj(e),
            }));
    }
    deleteOnboardingHistoryFields({ userId, historyName, id }: any) {
        return this.delete(`/${userId}/${historyName}/${id}`)
            .then((response) => ({
                isSuccess: true,
                data: response,
            }))
            .catch((e) => ({
                isSuccess: false,
                data: parsErrorMessageObj(e),
            }));
    }
    updateHistory({ status, matchedKeys, id, tab, options }: IUpdateHistory) {
        const body: any = { status, histories: convertDotNotationToNested(matchedKeys), tab };
        if (options) {
            body.options = options;
        }
        return this.put(`/${id}`, body);
    }
    getRelevant(userId: string, period: string) {
        return this.get(`/${userId}/relevant?period=${period}&keys=expensesForOptimization,mealAllowance`);
    }
    //TODO
    getRelevantInvoice(userId: string, period: string) {
        return this.get(`/${userId}/relevant?period=${period}&keys=invoiceCurrency`);
    }
}

export const historyApi = new HistoryApi();
